module.exports = __webpack_public_path__ + "static/media/11-8.2574df11.mp3";